import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { useState } from 'react';
import { useTranslation } from '@crehana/i18n';
import { LANGUAGES } from '@crehana/ts-types';
import { ChipGroup } from "../ChipGroup/chip-group";
import { Dropdown, DropdownContent, DropdownEmpty, DropdownSearchInput, DropdownValue } from "./Dropdown";
import { DropdownCheckboxList } from "./DropdownCheckboxList";
import { DropdownTextList } from "./DropdownTextList";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var i18n = /*#__PURE__*/_defineProperty(/*#__PURE__*/_defineProperty(/*#__PURE__*/_defineProperty({}, LANGUAGES.ES, {
  clearButton: 'Borrar todo',
  inputPlaceholder: 'Seleccione las opciones',
  noFoundPlaceholderTitle: 'No se han encontrado resultados',
  noFoundPlaceholderSubtitle: 'Prueba palabras clave más generales'
}), LANGUAGES.PT, {
  clearButton: 'Limpar',
  inputPlaceholder: 'Selecione as opções',
  noFoundPlaceholderTitle: 'Nenhum resultado encontrado',
  noFoundPlaceholderSubtitle: 'Tente palavras-chave mais gerais'
}), LANGUAGES.EN, {
  clearButton: 'Clear all',
  inputPlaceholder: 'Select options',
  noFoundPlaceholderTitle: 'No results found',
  noFoundPlaceholderSubtitle: 'Try more general keywords'
});
var MAX_CHIPS_ROWS = 1;
var EXTRA_WIDTH_FROM_CLOSE = 28;
export function DropdownWithChips(_ref) {
  var items = _ref.items,
    placeholderProp = _ref.placeholder,
    loading = _ref.loading,
    selectedProp = _ref.selected,
    onSelectProp = _ref.onSelect,
    labels = _ref.labels,
    _ref$maxChipsRows = _ref.maxChipsRows,
    maxChipsRows = _ref$maxChipsRows === void 0 ? MAX_CHIPS_ROWS : _ref$maxChipsRows,
    _ref$extraWidthFromCl = _ref.extraWidthFromClose,
    extraWidthFromClose = _ref$extraWidthFromCl === void 0 ? EXTRA_WIDTH_FROM_CLOSE : _ref$extraWidthFromCl,
    forcedValue = _ref.forcedValue,
    searchInputPlaceholder = _ref.searchInputPlaceholder,
    itemListVariant = _ref.itemListVariant,
    disabled = _ref.disabled,
    open = _ref.open,
    onOpenChange = _ref.onOpenChange;
  var _useTranslation = useTranslation(),
    languageCode = _useTranslation.languageCode;
  var locales = i18n[languageCode];
  var _useState = useState(selectedProp !== null && selectedProp !== void 0 ? selectedProp : []),
    _useState2 = _slicedToArray(_useState, 2),
    _selectedItems = _useState2[0],
    _setSelectedItems = _useState2[1];

  // controlled props
  var selected = selectedProp || _selectedItems;
  var _onSelect = onSelectProp || _setSelectedItems;
  var placeholder = placeholderProp || locales.inputPlaceholder;
  var clearButtonLabel = (labels === null || labels === void 0 ? void 0 : labels.clearButton) || locales.clearButton;
  var noFoundPlaceholderTitle = (labels === null || labels === void 0 ? void 0 : labels.noFoundPlaceholderTitle) || locales.noFoundPlaceholderTitle;
  var noFoundPlaceholderSubtitle = (labels === null || labels === void 0 ? void 0 : labels.noFoundPlaceholderSubtitle) || locales.noFoundPlaceholderSubtitle;
  var itemListVariantJsx = {
    checkbox: /*#__PURE__*/_jsx(DropdownCheckboxList, {
      items: items,
      selected: selected,
      onSelect: function onSelect(values) {
        _onSelect(values);
      }
    }),
    text: /*#__PURE__*/_jsx(DropdownTextList, {
      items: items,
      selected: selected,
      onSelect: function onSelect(values) {
        _onSelect(values);
      },
      multiselect: true
    })
  }[itemListVariant];
  var onDelete = function onDelete(value) {
    _onSelect(selected.filter(function (el) {
      return el !== value;
    }));
  };
  var onClearAll = function onClearAll() {
    _onSelect([]);
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(Dropdown, {
      open: open,
      onOpenChange: onOpenChange,
      children: [/*#__PURE__*/_jsx(DropdownValue, {
        size: "small",
        placeholder: placeholder,
        disabled: disabled || loading,
        forcedValue: forcedValue || placeholder
      }), /*#__PURE__*/_jsxs(DropdownContent, {
        removePortal: true,
        children: [/*#__PURE__*/_jsx(DropdownSearchInput, {
          placeholder: searchInputPlaceholder || placeholder
        }), /*#__PURE__*/_jsx(DropdownEmpty, {
          title: noFoundPlaceholderTitle,
          subtitle: noFoundPlaceholderSubtitle
        }), itemListVariantJsx]
      })]
    }), /*#__PURE__*/_jsx(ChipGroup, {
      items: items,
      selected: selected,
      onDelete: onDelete,
      onClearAll: onClearAll,
      maxChipsRows: maxChipsRows,
      extraWidthFromClose: extraWidthFromClose,
      clearButtonLabel: clearButtonLabel
    })]
  });
}